export const LANDING = '/';
export const SIGN_IN = '/signin';
export const MAIN = '/main';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const ADMIN = '/admin';
export const ADMIN_DETAILS = '/admin/:id';
